import { Dictionary } from 'vuex';

import { MdokResource, mdokResource } from '@/resources/mdok.resource';
import { AbstractModule } from './abstract.module';

/**
 * Moduł MDOK
 *
 * @export
 * @class MdokModule
 * @extends {AbstractModule<MdokResource>}
 */
export class MdokModule extends AbstractModule<MdokResource> {
  public state: object = { name: undefined, caseName: undefined };
  public actions: Dictionary<(...args: any[]) => any> = {
    /**
     * Pobiera nazwę dokumentu z MDOK
     *
     * @param {*} context
     * @param {{ uid: number; documentId: number }} variables
     * @returns {Promise<string>}
     */
    getDocumentName: (context: any, variables: { uid: number; documentId: number }): Promise<string> =>
      this.resource
        .getDocumentName(variables)
        .then(name => {
          context.commit('saveDocumentName', name);
          return name;
        })
        .catch(err => {
          context.commit('saveDocumentName', null);
          throw err;
        }),

    /**
     * Pobiera nazwę sprawy z MDOK
     *
     * @param {*} context
     * @param {{ uid: number; documentId: number }} variables
     * @returns {Promise<string>}
     */
    getCaseName: (context: any, variables: { uid: number; documentId: number }): Promise<string> =>
      this.resource
        .getCaseName(variables)
        .then(name => {
          context.commit('saveCaseName', name);
          return name;
        })
        .catch(err => {
          context.commit('saveCaseName', null);
          throw err;
        })
  };
  public mutations: Dictionary<(...args: any[]) => void> = {
    /**
     * Zapisuje nazwę dokumentu
     *
     * @param {*} localState
     * @param {string} name
     */
    saveDocumentName(localState: any, name: string): void {
      localState.name = name;
    },

    /**
     * Zapisuje nazwę sprawy
     *
     * @param {*} localState
     * @param {string} name
     */
    saveCaseName(localState: any, name: string): void {
      localState.caseName = name;
    }
  };
}

export default new MdokModule(mdokResource);
